// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_lf-0";